// Module
var code = `{{#multiList}}
<h1>MULTILIST ITEM {{classVal}}</h1>
<p class="docs-item-block-p {{classVal}}">{{text}}</p>

{{/multiList}}
`;
// Exports
module.exports = code;